module.exports = __webpack_public_path__ + "media/images/icons/country_flags/na-121ad7c836aa668ada660a5b13610e4e.svg";